export default "__VITE_ASSET__aaaddee4__"